import { render, staticRenderFns } from "./bxwgdet.vue?vue&type=template&id=abd7b99e&scoped=true&"
import script from "./bxwgdet.vue?vue&type=script&lang=js&"
export * from "./bxwgdet.vue?vue&type=script&lang=js&"
import style0 from "./bxwgdet.vue?vue&type=style&index=0&id=abd7b99e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd7b99e",
  null
  
)

export default component.exports